module.exports = __webpack_public_path__ + "static/media/fm.97c5bb37.svg";